import { useMemo } from 'react';

interface Base {
    page: number;
    size: number;
    sort?: {
        field: 'vendor' | 'product' | 'cves';
        direction: 'asc' | 'desc';
    };
}

interface State extends Base {
    cvss?: string;
}

interface Payload extends Base {
    score?: number;
}

export function useCvssProductCatalogPayload(state: State) {
    const payload: Payload = useMemo(
        () => ({
            page: state.page,
            size: state.size,
            score: state.cvss ? parseInt(state.cvss) : undefined,
            sort: state.sort
        }),
        [state.cvss, state.page, state.size, state.sort]
    );

    return payload;
}
